(function(){
  var link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = 'https://capecobra.com/cdn/shop/files/favicon.png';
  document.head.appendChild(link);
})();
(function () {
  var modal = document.getElementById('rc-lp1-location-modal');
  var frame = document.getElementById('rc-lp1-our-location-iframe');
  if (!modal || !frame) return;

  function openModal() {
    if (!frame.src) frame.src = frame.dataset.src;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.rc-lp1-our-location-trigger')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('[data-close]') && modal.contains(e.target.closest('[data-close]'))) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();

(function () {
  var modal = document.getElementById('policy-modal');
  var frame = document.getElementById('policy-modal-frame');
  if (!modal || !frame) return;

  function openModal(url) {
    frame.src = url;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    frame.src = '';
  }

  // document.querySelector('.rc-lp1-policies').addEventListener('click', function (e) {
  //   var link = e.target.closest('a[href]');
  //   if (!link) return;
  //   e.preventDefault();
  //   openModal(link.href);
  // });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();

(function () {
  var modal = document.getElementById('float-modal');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.float-how-it-works-trigger')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('[data-close]') && modal.contains(e.target.closest('[data-close]'))) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();

(function () {
  var container = document.querySelector('.rc-lp1-hero__products');
  if (!container) return;
  var items = Array.prototype.slice.call(container.querySelectorAll('.rc-lp1-hero__product'));
  if (items.length < 2) return;

  var current = 0;

  function goTo(idx) {
    items[current].classList.remove('is-active');
    current = idx;
    items[current].classList.add('is-active');
  }

  goTo(0);

  var timer = setInterval(function () { goTo((current + 1) % items.length); }, 3500);
  container.addEventListener('mouseenter', function () { clearInterval(timer); });
  container.addEventListener('mouseleave', function () {
    timer = setInterval(function () { goTo((current + 1) % items.length); }, 3500);
  });
})();
(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  document.querySelectorAll('.rc-lp1-pdp__images').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 1,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true }
    });
  });
})();
/* Cape Cobra — interactive behaviour */
(function () {
  'use strict';

  // ----------------------------------------------------------
  // Sticky nav: show after scrolling past the hero, hide near
  // the closing CTA strip.
  // ----------------------------------------------------------
  var nav = document.getElementById('rc-lp1-nav');
  var hero = document.querySelector('.rc-lp1-hero');
  var closeStrip = document.querySelector('.rc-lp1-close');

  function onScroll() {
    if (!nav || !hero) return;
    var heroBottom = hero.getBoundingClientRect().bottom;
    var pastHero = heroBottom < 0;

    var nearClose = false;
    if (closeStrip) {
      var ct = closeStrip.getBoundingClientRect().top;
      nearClose = ct < 200;
    }
    nav.classList.toggle('is-visible', pastHero && !nearClose);
  }
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ----------------------------------------------------------
  // Smooth scroll for in-page anchors, with sticky-nav offset
  // ----------------------------------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href^="#"]');
    if (!t) return;
    var id = t.getAttribute('href').slice(1);
    if (!id) return;
    var dest = document.getElementById(id);
    if (!dest) return;
    e.preventDefault();
    var y = dest.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // close mobile menu after navigation
    if (nav) nav.classList.remove('is-open');
  });

  // ----------------------------------------------------------
  // Active-state observer for product anchor links
  // ----------------------------------------------------------
  var navLinks = Array.prototype.slice.call(document.querySelectorAll('.rc-lp1-nav__link'));
  var sections = navLinks
    .map(function (a) { return document.getElementById(a.dataset.anchor); })
    .filter(Boolean);

  function updateActiveLink() {
    var active = null;
    sections.forEach(function (s) {
      if (s.getBoundingClientRect().top <= window.innerHeight * 0.4) {
        active = s;
      }
    });
    navLinks.forEach(function (a) {
      a.classList.toggle('is-active', active !== null && a.dataset.anchor === active.id);
    });
  }
  document.addEventListener('scroll', updateActiveLink, { passive: true });
  updateActiveLink();

  // ----------------------------------------------------------
  // Mobile menu toggle
  // ----------------------------------------------------------
  var menuBtn = document.querySelector('.rc-lp1-nav__menu');
  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var m = document.getElementById('rc-lp1-nav-mobile');
      if (m) m.hidden = !open;
    });
  }

  // ----------------------------------------------------------
  // Exit-intent modal (desktop only, max once per session)
  // ----------------------------------------------------------
  var modal = document.getElementById('rc-lp1-modal');
  if (modal) {
    var shown = false;
    try { shown = sessionStorage.getItem('rc-lp1-exit-shown') === '1'; } catch (e) {}

    function showModal() {
      if (shown) return;
      shown = true;
      try { sessionStorage.setItem('rc-lp1-exit-shown', '1'); } catch (e) {}
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
    }
    function hideModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }

    // Trigger when cursor moves toward the top edge (likely heading for close)
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
        // Only show after the user has scrolled a bit — avoid first-paint pop
        if (window.pageYOffset > 600) showModal();
      }
    });

    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-close]')) hideModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) hideModal();
    });
  }
})();



/* Cape Cobra v2 — currency switch, configurator, mobile buy bar */
(function () {
  'use strict';
  
  // ----------------------------------------------------------
  // Currency switcher — ZAR / USD
  //   USD reads data-usd attribute directly; falls back to /18.6 if absent.
  // ----------------------------------------------------------
  var RATES = {
    ZAR: { fmt: function(v){ return 'R ' + format(v); } },
    USD: { fmt: function(v){ return '$'       + format(v / 18.6); } }
  };
  function format(n){
    if (n >= 1000) return Math.round(n).toLocaleString('en-US');
    return n.toFixed(0);
  }
  function fmtUsd(el, zar){
    var usd = parseFloat(el.getAttribute('data-usd'));
    return '$' + format(!isNaN(usd) ? usd : zar / 18.6);
  }

  var curButtons = Array.prototype.slice.call(document.querySelectorAll('.rc-lp1-cur__btn'));
  var moneyEls = Array.prototype.slice.call(document.querySelectorAll('.rc-lp1-money'));

  function applyCurrency(code) {
    if (!RATES[code]) return;
    moneyEls.forEach(function (el) {
      var zar = parseFloat(el.getAttribute('data-zar'));
      if (isNaN(zar)) return;
      var isAlt = el.classList.contains('rc-lp1-money--alt');
      if (code === 'ZAR') {
        el.textContent = isAlt ? fmtUsd(el, zar) : RATES.ZAR.fmt(zar);
      } else {
        el.textContent = isAlt ? RATES.ZAR.fmt(zar) : fmtUsd(el, zar);
      }
    });
    curButtons.forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.cur === code);
    });
    try { localStorage.setItem('rc-lp1-cur', code); } catch (e) {}
  }

  curButtons.forEach(function (b) {
    b.addEventListener('click', function () { applyCurrency(b.dataset.cur); });
  });

  // initial — read prior choice, otherwise ZAR
  var initCur = 'ZAR';
  try {
    var stored = localStorage.getItem('rc-lp1-cur');
    if (stored && RATES[stored]) initCur = stored;
  } catch (e) {}
  applyCurrency(initCur);

  // ----------------------------------------------------------
  // PDP hardware configurator
  //   Updates active visual state AND the spec-table row.
  // ----------------------------------------------------------
  document.querySelectorAll('.rc-lp1-config').forEach(function (group) {
    var opts = group.querySelectorAll('.rc-lp1-config__opt');
    var pdp = group.closest('.rc-lp1-pdp');
    var bind = group.dataset.config;
    var target = pdp ? pdp.querySelector('[data-spec-bind="' + bind + '"]') : null;
    var orderBtn = pdp ? pdp.querySelector('.rc-lp1-pdp__buy .rc-lp1-btn--primary') : null;

    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
        opt.classList.add('is-active');
        opt.setAttribute('aria-checked', 'true');
        if (target) target.textContent = opt.dataset.spec;
        var vid = opt.dataset.variation;
        if (vid && pdp) {
          pdp.setAttribute('data-variation', vid);
          if (orderBtn) orderBtn.setAttribute('href', '/cart/' + vid + ':1');
          if (mbarCta && currentPdp === pdp) mbarCta.setAttribute('href', '/cart/' + vid + ':1');
        }
      });
    });
  });

  // ----------------------------------------------------------
  // Sticky mobile buy bar: shows when a PDP is in view.
  //   Reads its data from the active PDP — price + name + WA + Order link.
  // ----------------------------------------------------------
  var mbar = document.getElementById('rc-lp1-mbar');
  var mbarName = document.getElementById('rc-lp1-mbar-name');
  var mbarPrice = document.getElementById('rc-lp1-mbar-price');
  var mbarCta = mbar ? mbar.querySelector('.rc-lp1-mbar__cta') : null;

  var pdps = Array.prototype.slice.call(document.querySelectorAll('.rc-lp1-pdp'));
  if (mbar && pdps.length && 'IntersectionObserver' in window) {
    var currentPdp = null;

    function refreshMbar(pdp) {
      if (!pdp || pdp === currentPdp) return;
      currentPdp = pdp;
      var nameEl = pdp.querySelector('.rc-lp1-pdp__name');
      var priceEl = pdp.querySelector('.rc-lp1-pdp__buy .rc-lp1-money');
      if (nameEl) mbarName.textContent = nameEl.textContent.trim();
      if (priceEl) {
        var zar = priceEl.getAttribute('data-zar');
        var usdAttr = priceEl.getAttribute('data-usd');
        mbarPrice.setAttribute('data-zar', zar);
        if (usdAttr) mbarPrice.setAttribute('data-usd', usdAttr);
        else mbarPrice.removeAttribute('data-usd');
        var active = curButtons.find(function (b) { return b.classList.contains('is-active'); });
        var code = active ? active.dataset.cur : 'ZAR';
        mbarPrice.textContent = code === 'USD' ? fmtUsd(mbarPrice, parseFloat(zar)) : RATES.ZAR.fmt(parseFloat(zar));
      }
      if (mbarCta) {
        var vid = pdp.getAttribute('data-variation');
        mbarCta.setAttribute('href', vid ? '/cart/' + vid + ':1' : '#' + pdp.id);
      }
    }

    var pdpIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) refreshMbar(entry.target);
      });
    }, { threshold: 0.25 });
    pdps.forEach(function (p) { pdpIo.observe(p); });

    // Show/hide based on whether we are scrolled into PDP territory
    var firstPdp = pdps[0];
    var lastPdp = pdps[pdps.length - 1];
    function maybeShowMbar() {
      if (!firstPdp) return;
      var inRange =
        firstPdp.getBoundingClientRect().top < window.innerHeight * 0.6 &&
        lastPdp.getBoundingClientRect().bottom > 0;
      mbar.hidden = false;
      mbar.classList.toggle('is-visible', inRange);
    }
    document.addEventListener('scroll', maybeShowMbar, { passive: true });
    maybeShowMbar();
  }
})();
